// Client wrapper for /api/predict. Debounced - the caller should only invoke this
// after a brief pause in typing to keep API calls bounded.

export async function predictNextWords(input: {
  questionText: string;
  partial: string;
  expectedFormat?: string;
  signal?: AbortSignal;
}): Promise<string[]> {
  try {
    const response = await fetch('/api/predict', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        questionText: input.questionText,
        partial: input.partial,
        expectedFormat: input.expectedFormat,
      }),
      signal: input.signal,
    });
    if (!response.ok) return [];
    const body = (await response.json()) as { candidates?: string[] };
    return Array.isArray(body.candidates) ? body.candidates.slice(0, 3) : [];
  } catch (e) {
    if ((e as { name?: string }).name === 'AbortError') return [];
    return [];
  }
}
